import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { KPPlanetSignificatorCuspalView } from './KPPlanetSignificatorCuspalView';
import { KPPlanetSignificatorPlanetView } from './KPPlanetSignificatorPlanetView';

export function KPPlanetSignificatorChart ({menuArray,userData}) {
  return(
    <>
      { userData===null || userData===undefined?<></>:
          <Collapse in={menuArray[2]} className="m-0 p-0 ">
              <Row id="planetSignificatorsChart" className="m-0 p-0">
                  <Col xs={12} md={6} className="p-2 pt-0 m-0 ">
                    <KPPlanetSignificatorCuspalView userData={userData}/>
                  </Col>
                  <Col xs={12} md={6} className="p-2 pt-0 m-0">
                    <KPPlanetSignificatorPlanetView userData={userData}/>
                  </Col>
              </Row>
          </Collapse>
    }
  </>  
  );
}